import script from "./PreOrderList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreOrderList.vue?vue&type=script&setup=true&lang=ts"

import "./PreOrderList.vue?vue&type=style&index=0&id=9af2e2a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af2e2a4"]])

export default __exports__